import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import { last, sortBy } from 'lodash';
import Dropzone from 'react-dropzone';

import Modal from '../../ui/modal';
import Textfield from '../../ui/text-field';

import * as endpoints from '../../../helpers/endpoints';
import apiRequest from '../../../helpers/apiRequest';

import validObj from '../../../helpers/validateObj';
import aaSave from '../../../helpers/afterActionSave';
import aaValidation from '../../../helpers/afterActionValidation';

class UploadFiles extends Component {
    constructor(props) {
        super(props);
        this.state = { userAction: null };
    }

    handleSubmit = e => {
        const formObj = validObj(e);
        formObj.id = formObj.reportId;
        switch (this.props.userAction) {
            case 'save':
                formObj.deliverable = formObj.aadeliverable;
                formObj.recommend = formObj.aaRecommend;
                formObj.approverId = formObj.aaApproverId;
                this.props.updateAfterAction(formObj);
                break;
            case 'submit':
                const notValid = aaValidation(e);
                if (!notValid) {
                    formObj.recommend = formObj.aaRecommend;
                    formObj.deliverable = formObj.aadeliverable;
                    this.props.submitAfterAction(formObj);
                } else {
                    this.props.setEventErrorMessage(notValid);
                    if (e.aaawareness !== true && e.aabehavior !== true) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            false
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            false
                        );
                    } else if (
                        e.aaawareness === true ||
                        e.aabehavior === true
                    ) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            true
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            true
                        );
                    }
                }
                break;
            case 'approve':
                this.props.approveAfterAction(formObj);
                break;
            case 'request':
                this.props.requestInfoAfterAction(formObj);
                break;
            default:
                console.log(this.props.userAction);
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'save') {
            const values = aaSave(e);
            this.props.updateAfterAction(values);
        }
        if (this.props.userAction === 'request') {
            const values = aaSave(e);
            this.props.requestInfoAfterAction(values);
        }
    };

    onDrop(files) {
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let formData = new FormData();
            formData.append('userfile', file);
            window.URL.revokeObjectURL(file.preview);
            apiRequest(
                `${endpoints.MEDIA_UPLOAD}`,
                this.props.jwtToken,
                'POST',
                formData,
                true
            )
                .then(response => {
                    console.log(response);
                    let filesArray = response.data[0];
                    let id = this.props.eventForm.EventReport.id;
                    let payload = {
                        id: filesArray.id,
                        type: 'EventReport',
                        eventId: id
                    };
                    this.props.associateUploadedFile(payload);
                    this.props.uploadedFiles(filesArray);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    removeFile(item, index) {
        const id = item.id;
        let payload = {
            id: id,
            type: 'EventReport',
            eventId: 0
        };

        this.props.associateUploadedFile(payload);
        this.props.removeUploadedFiles(index, payload);
    }

    render() {
        let saveSubmit = false;
        let approveReject = false;
        let userInfo = this.props.userInfo;
        const trustingUserId = userInfo.TrustingUser
            ? userInfo.TrustingUser.id
            : null;

        if (
            this.props.groupStatus.status === 'After Action Incomplete' ||
            this.props.groupStatus.status === 'After Action Pending'
        ) {
            if (
                this.props.afterActionUserID === this.props.userInfo.id ||
                this.props.afterActionUserID === trustingUserId
            ) {
                saveSubmit = true;
            }
        } else if (
            this.props.eventState.EventReport.status === 'Unapproved' &&
            this.props.groupStatus.status === 'After Action Review' &&
            this.props.tasks &&
            this.props.tasks.length > 0
        ) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
            if (mostRecentTask.userId === this.props.userInfo.id) {
                if (mostRecentTask.action === 'Info') {
                    saveSubmit = true;
                } else {
                    approveReject = true;
                }
            }
        }

        let noFilesUploaded = false;
        if (!saveSubmit) {
            if (!this.props.uploadedFilesArray) {
                noFilesUploaded = true;
            } else if (
                this.props.uploadedFilesArray &&
                this.props.uploadedFilesArray.length === 0
            ) {
                noFilesUploaded = true;
            }
        }

        return (
            <Form
                className="form"
                model="event"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Upload Files</div>

                {noFilesUploaded ? (
                    <p>No files were uploaded for this event.</p>
                ) : null}

                {saveSubmit ? (
                    <Dropzone
                        className="form--upload"
                        onDrop={this.onDrop.bind(this)}
                    >
                        <div className="form__row">
                            <div className="form__title">
                                Drag Files Here
                                <span className="form__teaser">
                                    JPG, JPEG, PDF, DOC, PNG
                                </span>
                                <span className="form__teaser form__teaser--seperator">
                                    or
                                </span>
                            </div>
                            <div className="form__row-upload">
                                <button
                                    type="button"
                                    className="btn btn--secondary"
                                >
                                    Choose Files
                                </button>
                            </div>
                        </div>
                    </Dropzone>
                ) : null}

                <div className="files">
                    {this.props.uploadedFilesArray !== undefined &&
                        this.props.uploadedFilesArray.map((item, index) => (
                            <div className="files__entry" key={index}>
                                <div className="files__name">
                                    <span className="files__type">
                                        <svg className="icon icon-image">
                                            <use
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                // xlinkHref="#icon-image"
                                                xlinkHref={`#icon-${
                                                    item.mediaType
                                                }`}
                                            />
                                        </svg>
                                    </span>
                                    {item.name}
                                </div>

                                <div className="files__actions">
                                    <a
                                        className="files__download"
                                        target="_blank"
                                        href={`https://${
                                            endpoints.envCheck
                                        }ems.marines.com${item.links[0].self}`}
                                    >
                                        <svg className="icon icon-download">
                                            <use
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                xlinkHref="#icon-download"
                                            />
                                        </svg>
                                    </a>
                                    {saveSubmit && (
                                        <span
                                            className="files__delete"
                                            onClick={() => {
                                                this.removeFile(item, index);
                                            }}
                                        >
                                            <svg className="icon icon-trash">
                                                <use
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    xlinkHref="#icon-trash"
                                                />
                                            </svg>
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                </div>

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                />

                <div className="form__actions form__actions--global">
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--secondary btn--save"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="approve"
                            onClick={() => {
                                this.props.setEventUserAction('approve');
                            }}
                        >
                            Approve
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.aaRequestComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                </div>
            </Form>
        );
    }
}

export default UploadFiles;



// WEBPACK FOOTER //
// ./src/components/event/after-action/upload-files.js